

export const frontMatter = {
	sidebar_position: 3
};
export const contentTitle = 'Араматызацыя';
export {default as metadata} from '@site/.docusaurus/docusaurus-plugin-content-docs/default/site-i-18-n-be-docusaurus-plugin-content-docs-current-learn-vocabulary-flavourisation-md-157.json'
export const assets = {

};

import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import Tabs from '@theme/Tabs';
import TabItem from '@theme/TabItem';
import {translate} from "@docusaurus/Translate";
export const toc = [{
  "value": "Міжславянскія дыялекты",
  "id": "interslavic-dialects",
  "level": 2
}, {
  "value": "Араматызацыя ў вымаўленні",
  "id": "flavourisation-in-pronunciation",
  "level": 2
}, {
  "value": "Поўнач і Поўдзень",
  "id": "north-and-south",
  "level": 4
}, {
  "value": "Араматызацыя ў правапісе",
  "id": "flavourisation-in-spelling",
  "level": 2
}, {
  "value": "Прыклады",
  "id": "examples",
  "level": 2
}, {
  "value": "Etymological alphabet",
  "id": "etymological-alphabet",
  "level": 3
}, {
  "value": "Standard Latin alphabet",
  "id": "standard-latin-alphabet",
  "level": 3
}, {
  "value": "Standard Cyrillic alphabet",
  "id": "standard-cyrillic-alphabet",
  "level": 3
}, {
  "value": "Northern variant, East Slavic orthography",
  "id": "northern-variant-east-slavic-orthography",
  "level": 3
}, {
  "value": "Northern variant, Polish-based orthography",
  "id": "northern-variant-polish-based-orthography",
  "level": 3
}, {
  "value": "Southern variant, Croatian-based orthography",
  "id": "southern-variant-croatian-based-orthography",
  "level": 3
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    em: "em",
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    header: "header",
    li: "li",
    p: "p",
    span: "span",
    strong: "strong",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  }, {CustomAfterSection, CustomBeforeSection, IPA, MDFlavourisation1, MDFlavourisation2, MDFlavourisation3, TransliteratorElement} = _components;
  if (!CustomAfterSection) _missingMdxReference("CustomAfterSection", true);
  if (!CustomBeforeSection) _missingMdxReference("CustomBeforeSection", true);
  if (!IPA) _missingMdxReference("IPA", true);
  if (!MDFlavourisation1) _missingMdxReference("MDFlavourisation1", true);
  if (!MDFlavourisation2) _missingMdxReference("MDFlavourisation2", true);
  if (!MDFlavourisation3) _missingMdxReference("MDFlavourisation3", true);
  if (!TransliteratorElement) _missingMdxReference("TransliteratorElement", true);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.header, {
      children: _jsx(_components.h1, {
        id: "араматызацыя",
        children: "Араматызацыя"
      })
    }), "\n", _jsx(_components.h2, {
      id: "interslavic-dialects",
      children: "Міжславянскія дыялекты"
    }), "\n", _jsx(CustomBeforeSection, {}), "\n", _jsxs(_components.p, {
      children: ["Міжславянская мова павінна быць як мага больш у цэнтры славянскіх моў, і мы робім усё магчымае, каб прапанаваць рашэнні, якія лепш за ўсё падыходзяць для ўсіх славян разам, пазбягаючы перавагі характарыстык асобных падгруп. Гэтыя рашэнні, аднак, не заўсёды ідэальныя для камунікацыі паміж ", _jsx(_components.em, {
        children: "падгрупай"
      }), " славянамоўных: тое, што лепшае ў Балгарыі ці Харватыі, неабавязкова лепшае ў Польшчы ці Расіі. Interslavic павінен быць дастаткова гнуткім, каб прапаноўваць рашэнні для ўсіх гэтых розных тыпаў камунікацыі. Гэта можа быць рэалізавана на чатырох розных узроўнях:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "На лексічным узроўні. Міжславянскія словы адбіраліся так, каб яны былі максімальна зразумелымі сярод найбольшай колькасці славян, але не заўсёды можна знайсці слова, зразумелае ўсім. Відавочна, што слова, агульназразумелае заходнім і ўсходнім славянам, але невядомае паўднёвым славянам, не вельмі дапаможа ў зносінах з сербамі ці балгарамі. Па гэтай прычыне ў слоўніку часам даюцца сінонімы, дзе адно слова ахоплівае адну частку славянскай тэрыторыі, а другое — іншую, што дазваляе карыстальнікам выбраць словы, зразумелыя канкрэтна адной падгрупе."
      }), "\n", _jsxs(_components.li, {
        children: ["На фаналагічным узроўні. Нават калі слова сустракаецца ва ўсіх славянскіх мовах, яно неабавязкова ўсюды гучыць аднолькава. Напрыклад, расейцы і ўкраінцы выкарыстоўваюць ", _jsx(_components.span, {
          className: "notranslate",
          translate: "no",
          children: "korova"
        }), " для каровы, палякі і лужыцкія сербы ", _jsx(_components.span, {
          className: "notranslate",
          translate: "no",
          children: "krowa"
        }), ", чэхі, славакі і паўднёвыя славяне ", _jsx(_components.span, {
          className: "notranslate",
          translate: "no",
          children: "krava"
        }), ". Для расейца ", _jsx(_components.span, {
          className: "notranslate",
          translate: "no",
          children: "krova"
        }), " лягчэй зразумець, чым ", _jsx(_components.span, {
          className: "notranslate",
          translate: "no",
          children: "krava"
        }), ", але няма прычынаў, чаму чэхі і/ці славакі павінны выкарыстоўваць яго ў зносінах з паўднёвымі славянамі, напрыклад."]
      }), "\n", _jsxs(_components.li, {
        children: ["На арфаграфічным узроўні. Пісьмовую міжславянскую мову можна зрабіць больш звыклай для носьбітаў пэўных моваў, выкарыстоўваючы арфаграфію, падобную да іх уласнай. Напрыклад, каб прыстасаваць рускамоўных, можна выкарыстоўваць ", _jsx(_components.code, {
          children: "я"
        }), ", ", _jsx(_components.code, {
          children: "ю"
        }), " і ", _jsx(_components.code, {
          children: "й"
        }), " замест формаў з кірыліцай ", _jsx(_components.code, {
          children: "ј"
        }), "."]
      }), "\n", _jsx(_components.li, {
        children: "На граматычным узроўні. Напрыклад, пазбягаючы выкарыстання інфінітываў і склонаў назоўнікаў пры звароце да балгар."
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "Працэс дадання мясцовага каларыту, каб міжславянская мова выглядала і гучала больш звыкла для носьбітаў пэўных моў, называецца «араматызацыяй». Магчымасці бясконцыя: для кожнай славянскай мовы ці дыялекту можна стварыць «нацыянальную» або «рэгіянальную» версію, якая, па ўсёй верагоднасці, створыць у носьбіта ўражанне смешнай, але цалкам зразумелай варыяцыі яго ўласнай мовы . Акрамя таго, араматызацыя дасягаецца не толькі адаптацыяй міжславянскай мовы да слухача/чытача, яна амаль непазбежна вызначаецца таксама мовай таго, хто гаворыць/пісе. Калі параўнаць міжславянскую мову, напісаную палякам, і міжславянскую, напісаную сэрбам, лёгка можна пазнаць адрозьненьні."
    }), "\n", _jsx(_components.p, {
      children: "Было б занадта далёка апісваць усе магчымыя араматызаваныя формы міжславянскага. Таму давайце засяродзімся на формах, прызначаных толькі для вялікіх груп, якія могуць быць рэалізаваны, надаючы большую вагу зразумеласці для некаторых славян, чым для іншых. Паколькі Interslavic выкарыстоўвае сістэму галасавання ў якасці інструмента для кампіляцыі слоў, граматычных канчаткаў і гукаў, вынік галасавання можа змяніцца, калі некаторым мовам надаецца меншая вага або ўвогуле выключаюцца. Такім чынам, замест рашэнняў, якія найбольш падыходзяць для ўсіх славян у цэлым, мы выкарыстоўваем характарыстыкі, характэрныя толькі для падмноства славянскіх моў. Вынік можна ахарактарызаваць як «дыялекты», некаторыя з большым уплывам усходнеславянскага, некаторыя з большым уплывам паўднёваславянскага і г.д."
    }), "\n", _jsx(_components.h2, {
      id: "flavourisation-in-pronunciation",
      children: "Араматызацыя ў вымаўленні"
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.em, {
        children: _jsx(_components.code, {
          children: "Flavorizacija v izgovoru"
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["Асновай для маніпулявання міжславянскім з'яўляецца ", _jsx(_components.a, {
        href: "/be/learn/orthography#etymological-alphabet",
        children: "этымалагічны алфавіт"
      }), ", набор неабавязковых літар, якія насамрэч не маюць уласнага вымаўлення, а ўяўляюць фанемы, вымаўленне якіх адрозніваецца ад адной мовы да другой. У міжславянскай мове яны могуць выкарыстоўвацца для перадачы дадатковай этымалагічнай інфармацыі, але яны могуць выкарыстоўвацца і з іншай мэтай: шляхам напісання і/або вымаўлення іх іншым (нестандартным) спосабам можна адаптаваць тэкст для лепшага разумення носьбітамі пэўнай групы моў."]
    }), "\n", _jsxs(_components.p, {
      children: ["Вымаўленне ", _jsx(_components.code, {
        children: "y"
      }), " адрозніваецца ад ", _jsx(_components.code, {
        children: "i"
      }), " толькі ў рускай, беларускай, польскай і лужыцкай мовах; у паўднёваславянскіх мовах, ва ўкраінскай і гутарковай чэшскай і славацкай мовах злілася з ", _jsx(_components.code, {
        children: "i"
      }), ". Такім чынам, калі вы звяртаецеся толькі да паўднёваславянскай аўдыторыі, абсалютна пажадана замяніць усе ", _jsx(_components.code, {
        children: "y"
      }), " на ", _jsx(_components.code, {
        children: "i"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["Галосная ", _jsx(_components.code, {
        children: "ě"
      }), " злілася з ", _jsx(_components.code, {
        children: "e"
      }), " у ", _jsx(_components.code, {
        children: "je"
      }), " (у рускай і польскай мовах) або ", _jsx(_components.code, {
        children: "e"
      }), " (у славенскай, сербскай і македонскай), але ў астатніх мовах яна па-рознаму развілася ў ", _jsx(_components.code, {
        children: "i"
      }), ", ", _jsx(_components.code, {
        children: "ije"
      }), ", ", _jsx(_components.code, {
        children: "je"
      }), ", ", _jsx(_components.code, {
        children: "ja"
      }), " або ", _jsx(_components.code, {
        children: "a"
      }), " (у той час як ", _jsx(_components.code, {
        children: "e"
      }), " заўсёды застаецца жорсткім ", _jsx(_components.code, {
        children: "e"
      }), "). У выніку сімвал ", _jsx(_components.code, {
        children: "ě"
      }), " валодае выдатнымі кампраміснымі якасцямі: серб можа чытаць ", _jsx(TransliteratorElement, {
        children: "rěč"
      }), " як свой ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        lang: "sr",
        children: "reč"
      }), ", харват як свой ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        lang: "hr",
        children: "riječ"
      }), ", украінец як свой ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        lang: "uk",
        children: "rič"
      }), ". Для расейцаў і палякаў розьніца неістотная."]
    }), "\n", _jsxs(_components.p, {
      children: ["Звычайна (гістарычна насавая) галосная ", _jsx(_components.code, {
        children: "ę"
      }), " пішацца і вымаўляецца як ", _jsx(_components.code, {
        children: "e"
      }), ", але гэта характэрная рыса для паўднёваславянскіх. Больш паўночнаславянскага каларыту можна дасягнуць, замяніўшы яго на ", _jsx(_components.code, {
        children: "ja"
      }), " (пасля мяккага зычнага ", _jsx(_components.code, {
        children: "a"
      }), ")."]
    }), "\n", _jsxs(_components.p, {
      children: ["Галосная ", _jsx(_components.code, {
        children: "ų"
      }), " адпавядае ", _jsx(_components.code, {
        children: "u"
      }), " у большасці славянскіх моў, акрамя польскай (", _jsx(_components.code, {
        children: "ą/ę"
      }), "), славенскай (", _jsx(_components.code, {
        children: "o"
      }), "), македонскай (", _jsx(_components.code, {
        children: "a"
      }), ") і балгарскай (", _jsx(_components.code, {
        children: "ъ"
      }), ")."]
    }), "\n", _jsxs(_components.p, {
      children: ["Літара ", _jsx(_components.code, {
        children: "å"
      }), " не існуе ні ў адной славянскай мове як асобная фанема. Міжславянская мова выкарыстоўвае ", _jsx(_components.code, {
        children: "a"
      }), " у гэтай пазіцыі, як і стараславянская, паўднёваславянская, чэшская, славацкая і многія словы ў рускай мове. Каб надаць тэксту больш паўночнаславянскі каларыт, замест яго можна выкарыстоўваць ", _jsx(_components.code, {
        children: "o"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["Літара ", _jsx(_components.code, {
        children: "ȯ"
      }), " абазначае моцны цвёрды джэр (", _jsx(_components.code, {
        children: "ъ"
      }), "). Усходнеславянская, славацкая, верхнелужыцкая і македонская маюць тут ", _jsx(_components.code, {
        children: "o"
      }), ", славенская і астатнія заходнеславянскія мовы ", _jsx(_components.code, {
        children: "e"
      }), ", сербскахарвацкая ", _jsx(_components.code, {
        children: "a"
      }), " і балгарская ", _jsx(_components.code, {
        children: "ъ"
      }), " (", _jsx(_components.code, {
        children: "ă"
      }), "). Interslavic мае ", _jsx(_components.code, {
        children: "o"
      }), " у гэтай пазіцыі, але для больш заходнеславянскага каларыту вы можаце выкарыстоўваць ", _jsx(_components.code, {
        children: "e"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["Літара ", _jsx(_components.code, {
        children: "ė"
      }), " абазначае моцны мяккі джэр (", _jsx(_components.code, {
        children: "ь"
      }), "). Ва ўсіх славянскіх мовах ён развіўся ў ", _jsx(_components.code, {
        children: "e"
      }), ", акрамя сербскахарвацкай, у якой ёсць ", _jsx(_components.code, {
        children: "a"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["Калі перад ", _jsx(_components.code, {
        children: "r"
      }), " або ", _jsx(_components.code, {
        children: "ŕ"
      }), " стаіць зычная, а не галосная, яны ўтвараюць асобны склад, які вымаўляецца хутчэй як ", _jsx(IPA, {
        children: "ǝr"
      }), " і ", _jsx(IPA, {
        children: "ʲǝr"
      }), ". У чэшскай, славацкай, славенскай, сербскахарвацкай і македонскай мовах яны аб'ядналіся ў складовы ", _jsx(_components.code, {
        children: "r"
      }), ". Для большага паўночна/ўсходнеславянскага каларыту вы можаце напісаць ", _jsx(_components.code, {
        children: "or"
      }), " для складовага ", _jsx(_components.code, {
        children: "r"
      }), " і ", _jsx(_components.code, {
        children: "er"
      }), " для складовага ", _jsx(_components.code, {
        children: "ŕ"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["Ва ўкраінскай, беларускай, чэшскай, славацкай і верхнелужыцкай мовах зычная ", _jsx(_components.code, {
        children: "g"
      }), " вымаўляецца хутчэй як прыдыхальнае ", _jsx(_components.code, {
        children: "h"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["У той час як у стандартнай міжславянскай мове ёсць два змякчаныя зычныя (", _jsx(_components.code, {
        children: "lj"
      }), " і ", _jsx(_components.code, {
        children: "nj"
      }), "), у этымалагічным алфавіце іх сем: ", _jsx(_components.code, {
        children: "ĺ ń ŕ t́ d́ ś ź"
      }), " (звярніце ўвагу, што ", _jsx(_components.code, {
        children: "lj"
      }), " і ", _jsx(_components.code, {
        children: "nj"
      }), " ідэнтычныя ", _jsx(_components.code, {
        children: "ĺ"
      }), " і ", _jsx(_components.code, {
        children: "ń"
      }), "). Астатнія пяць у асноўным адсутнічаюць у паўднёваславянскай мове, ", _jsxs(_components.strong, {
        children: [_jsx(_components.code, {
          children: "ś"
        }), " ", _jsx(_components.code, {
          children: "ź"
        })]
      }), " таксама ў чэшскай і славацкай і ", _jsx(_components.code, {
        children: "ŕ"
      }), " у славацкай і беларускай мовах. Калі вы хочаце надаць тэксту больш паўночнаславянскі выгляд, варта рэкамендаваць уключыць іх усе. У такім выпадку, вядома, было б лагічна, каб усе змякчаныя зычныя пазначаліся аднолькава: у кірыліцы мяккім знакам ", _jsx(_components.code, {
        children: "ь"
      }), ", у лацінскай арфаграфіі — акутам або караном (háček). Замест выкарыстання ", _jsx(_components.code, {
        children: "ľ"
      }), " або ", _jsx(_components.code, {
        children: "ĺ"
      }), " (абодва сустракаюцца толькі ў славацкай мове), таксама можна выкарыстоўваць ", _jsx(_components.code, {
        children: "l"
      }), " для мяккага ", _jsx(IPA, {
        children: "ʎ"
      }), " і ", _jsx(_components.code, {
        children: "ł"
      }), " для цвёрдага ", _jsx(IPA, {
        children: "l"
      }), ". Гэты метад выкарыстоўваецца ў польскай, лужыцкай і некаторых формах беларускай ", _jsx(_components.code, {
        children: "Łacinka"
      }), " і ўкраінскай ", _jsx(_components.code, {
        children: "Latynka"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["Літары ", _jsx(_components.code, {
        children: "ć"
      }), " і ", _jsx(_components.code, {
        children: "đ"
      }), " звычайна перадаюцца як ", _jsx(_components.code, {
        children: "č"
      }), " і ", _jsx(_components.code, {
        children: "dž"
      }), ", але ў больш паўднёваславянскай фармаце іх можна захаваць (напісаныя ", _jsx(_components.code, {
        children: "ћ"
      }), " і ", _jsx(_components.code, {
        children: "ђ"
      }), " кірыліцай). Ніколі не выкарыстоўвайце ", _jsx(_components.code, {
        children: "ћ"
      }), " і ", _jsx(_components.code, {
        children: "ђ"
      }), " для ", _jsx(_components.code, {
        children: "ть"
      }), " і ", _jsx(_components.code, {
        children: "дь"
      }), ", бо гэта розныя этымалагічныя сутнасці!"]
    }), "\n", _jsxs(_components.p, {
      children: ["Нарэшце, паслядоўнасць ", _jsx(_components.code, {
        children: "šč"
      }), " (кірыліца: ", _jsx(_components.code, {
        children: "шч"
      }), ") можа быць араматызавана ", _jsx(_components.code, {
        children: "št"
      }), " у паўднёваславянскай мове. Кірыліцай таксама можна пісаць ", _jsx(_components.code, {
        children: "щ"
      }), "."]
    }), "\n", _jsx(_components.h4, {
      id: "north-and-south",
      children: "Поўнач і Поўдзень"
    }), "\n", _jsx(_components.p, {
      children: "Зноў жа, колькасць магчымых камбінацый паміж мовамі амаль бясконцая, і было б занадта далёка апісваць кожную магчымую араматызаваную форму міжславянскай мовы. Найбольш відавочныя адрозьненьні паміж славянскімі мовамі можна пакрыць дзьвюма рознымі мадэлямі араматызацыі (у дадатак да «стандартнай» міжславянскай): больш арыентаванай на поўнач (засяроджаная на расейскай, беларускай, польскай і лужыцкай мовах, з другасным акцэнтам на чэскай, славацкай). і ўкраінская), і больш арыентаваная на поўдзень (засяроджаная вакол паўднёваславянскай, таксама з другасным акцэнтам на чэшскай, славацкай і ўкраінскай). Зыходзячы з папярэдняга абзаца, яны маглі б выглядаць наступным чынам (жоўтыя палі - палі, у якіх араматызаваная форма адрозніваецца ад стандартнай):"
    }), "\n", _jsx(MDFlavourisation1, {}), "\n", _jsxs(_components.p, {
      children: ["Акрамя таго, у інфінітывах паўночнай араматызацыі заканчваюцца на ", _jsx(_components.code, {
        children: "-ť"
      }), " замест ", _jsx(_components.code, {
        children: "-ti"
      }), ", назоўны/вінавальны склон адзіночнага ліку прыметнікаў павінен быць ", _jsx(_components.code, {
        children: "-e"
      }), " замест ", _jsx(_components.code, {
        children: "-o"
      }), " (", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: "dobre detja"
      }), " замест паўднёвага ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: "dobro děte"
      }), "). Паўночная араматызацыя аддае перавагу адноснаму займенніку ", _jsx(TransliteratorElement, {
        children: "ktory"
      }), ", а паўднёвая — ", _jsx(TransliteratorElement, {
        children: "koj"
      }), ". Сапраўды гэтак жа, у выпадку прэфікса ", _jsxs(_components.strong, {
        children: [_jsx(_components.code, {
          children: "vy"
        }), "-/", _jsx(_components.code, {
          children: "iz"
        }), "-"]
      }), ", першы арыентаваны на поўнач, а другі - на поўдзень. У паўднёвай араматызацыі прыназоўнік ", _jsx(TransliteratorElement, {
        children: "dlja"
      }), " «за» варта замяніць на ", _jsx(_components.em, {
        children: _jsx(_components.code, {
          children: "za"
        })
      }), "."]
    }), "\n", _jsx(_components.h2, {
      id: "flavourisation-in-spelling",
      children: "Араматызацыя ў правапісе"
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.em, {
        children: _jsx(_components.code, {
          children: "Flavorizacija v pravopisanju"
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["Міжславянскую мову таксама можна зрабіць больш даступнай для пэўных груп шляхам маніпулявання спосабам яе напісання. Стандартны лацінскі алфавіт у асноўным заснаваны на славенскім алфавіце з даданнем ", _jsx(_components.code, {
        children: "y"
      }), " (з заходнеславянскага) і ", _jsx(_components.code, {
        children: "ě"
      }), " (з чэшскага і лужыцкага). Гэты алфавіт, аднак, істотна адрозніваецца ад польскага алфавіту, і польскамоўныя могуць не адразу зразумець такія літары, як ", _jsx(_components.code, {
        children: "ě"
      }), " або ", _jsx(_components.code, {
        children: "š"
      }), ". Каб палегчыць ім задачу, можна, напрыклад, замяніць ", _jsx(_components.code, {
        children: "v"
      }), ", ", _jsx(_components.code, {
        children: "č"
      }), ", ", _jsx(_components.code, {
        children: "š"
      }), ", ", _jsx(_components.code, {
        children: "ž"
      }), " і ", _jsx(_components.code, {
        children: "ě"
      }), " на ", _jsx(_components.code, {
        children: "w"
      }), ", ", _jsx(_components.code, {
        children: "cz"
      }), ", ", _jsx(_components.code, {
        children: "sz"
      }), ", ", _jsx(_components.code, {
        children: "ż"
      }), " і ", _jsx(_components.code, {
        children: "ie"
      }), ". Палякам таксама дапаможа прыняцце ", _jsx(_components.code, {
        children: "ę"
      }), " і ", _jsx(_components.code, {
        children: "ų"
      }), " з этымалагічнага алфавіту, прадстаўленых як ", _jsx(_components.code, {
        children: "ię"
      }), " і ", _jsx(_components.code, {
        children: "ą"
      }), " адпаведна. Падобныя змены можна зрабіць і для носьбітаў іншых моў:"]
    }), "\n", _jsx(MDFlavourisation2, {}), "\n", _jsxs(_components.p, {
      children: ["Стандартны кірылічны алфавіт заснаваны на сербскай/македонскай кірыліцы з даданнем ", _jsx(_components.code, {
        children: "ы"
      }), " (з рускай і беларускай) і ", _jsx(_components.code, {
        children: "є"
      }), " (з украінскай). Гэта праблематычна тым, што ўсходнія славяне не заўсёды правільна разумеюць кірыліцу ", _jsx(_components.code, {
        children: "ј"
      }), ", якую яны схільныя вымаўляць як ", _jsx(_components.code, {
        children: "dž"
      }), ", як па-ангельску, у той час як многія паўднёвыя славяне не знаёмыя з літарай ", _jsx(_components.code, {
        children: "ы"
      }), ". У сытуацыях, калі тэкст прадстаўлены як лацінкай, так і кірыліцай, добрай ідэяй можа быць выкарыстаньне араматызаванага правапісу, спэцыяльна скіраванага да ўсходніх славян, бо сэрбы і македонцы больш знаёмыя з лацінскім альфабэтам."]
    }), "\n", _jsx(MDFlavourisation3, {}), "\n", _jsx(_components.h2, {
      id: "examples",
      children: "Прыклады"
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.em, {
        children: _jsx(_components.code, {
          children: "Priměry"
        })
      })
    }), "\n", _jsxs(Tabs, {
      children: [_jsxs(TabItem, {
        value: "etymological-alphabet",
        label: translate({
          id: "alphabet.orthography.examples.etymological",
          message: "Etymological alphabet"
        }),
        default: true,
        children: [_jsx(_components.h3, {
          id: "etymological-alphabet",
          children: "Etymological alphabet"
        }), _jsx(_components.p, {
          children: "Međuslovjańsky jest orųďje dlja komunikacije s Slovjanami. Učeńje ne jest tęžko i ne trȯvaje dȯlgo. Znajųći taky język, člověk imaje možnosť, da by izražal sę vȯ vśakoj slovjańskoj dŕžavě i råzuměl skoro vśe, čto ljudi k njemu govoręt i pišųt. S pomoćjų flavorizacije možno jest približati svoje teksty ješče bolje k regionaľnym ili městnym variantam, da by one iměli vęće vȯzhodnyh, sěvernyh, zapadnyh ili južnyh čŕt."
        })]
      }), _jsxs(TabItem, {
        value: "standard-latin-alphabet",
        label: "Standard Latin alphabet",
        children: [_jsx(_components.h3, {
          id: "standard-latin-alphabet",
          children: "Standard Latin alphabet"
        }), _jsx(_components.p, {
          children: "Medžuslovjansky jest orudje dlja komunikacije s Slovjanami. Učenje ne jest težko i ne trovaje dolgo. Znajuči taky jezyk, člověk imaje možnost, da by izražal se vo vsakoj slovjanskoj državě i razuměl skoro vse, čto ljudi k njemu govoret i pišut. S pomočju flavorizacije možno jest približati svoje teksty ješče bolje k regionalnym ili městnym variantam, da by one iměli veče vozhodnyh, sěvernyh, zapadnyh ili južnyh črt."
        })]
      }), _jsxs(TabItem, {
        value: "standard-cyrillic-alphabet",
        label: "Standard Cyrillic alphabet",
        children: [_jsx(_components.h3, {
          id: "standard-cyrillic-alphabet",
          children: "Standard Cyrillic alphabet"
        }), _jsx(_components.p, {
          children: "Меджусловјанскы јест орудје дља комуникације с Словјанами. Ученје не јест тежко и не троваје долго. Знајучи такы језык, чловєк имаје можност, да бы изражал се во всакој словјанској државє и разумєл скоро все, что људи к њему говорет и пишут. С помочју флаворизације можно јест приближати своје тексты јешче боље к регионалным или мєстным вариантам, да бы оне имєли вече возходных, сєверных, западных или јужных чрт."
        })]
      })]
    }), "\n", _jsxs(Tabs, {
      children: [_jsxs(TabItem, {
        value: "northern-variant-east-slavic-orthography",
        label: "Northern variant, East Slavic orthography",
        default: true,
        children: [_jsx(_components.h3, {
          id: "northern-variant-east-slavic-orthography",
          children: "Northern variant, East Slavic orthography"
        }), _jsx(_components.p, {
          children: "Меджусловяньски ест орудье для комуникацие с Словянами. Ученье не ест тяжко и не тровае долго. Знаючи такы язык, чловек имае можность, да бы изражал ся во всякой словяньской державе и розумел скоро все, что люди к ньему говорят и пишут. С помочю флаворизацие можно ест приближать свое тексты еще болье к региональным или местным вариантам, да бы оне имели вяче возходных, северных, западных или южных черт."
        })]
      }), _jsxs(TabItem, {
        value: "northern-variant-polish-based-orthography",
        label: "Northern variant, Polish-based orthography",
        children: [_jsx(_components.h3, {
          id: "northern-variant-polish-based-orthography",
          children: "Northern variant, Polish-based orthography"
        }), _jsx(_components.p, {
          children: "Miedżusłowiański jest orudie dla komunikacije s Słowianami. Uczenie nie jest tiażko i nie trowaje dołgo. Znajuczi taki jazyk, człowiek imaje możnosť, da by izrażał sia wo wsiakoj słowiańskoj dierżawie i rozumieł skoro wsie, czto ludi k niemu goworiat i piszut. S pomocziu flaworizacije możno jest pribliżati swoje teksty jeszcze bole k regionalnym ili miestnym wariantam, da by one imieli wiacze wozchodnych, siewiernych, zapadnych ili jużnych czert."
        })]
      }), _jsxs(TabItem, {
        value: "southern-variant-croatian-based-orthography",
        label: "Southern variant, Croatian-based orthography",
        children: [_jsx(_components.h3, {
          id: "southern-variant-croatian-based-orthography",
          children: "Southern variant, Croatian-based orthography"
        }), _jsx(_components.p, {
          children: "Međuslovjanski jest orudje dlja komunikacije s Slovjanami. Učenje ne jest težko i ne trăvaje dălgo. Znajući taki jezik, človjek imaje možnost, da bi izražal se vo vsakoj slovjanskoj državje i razumjel skoro vse, što ljudi k njemu govoret i pišut. S pomoćju flavorizacije možno jest približati svoje teksti ješte bolje k regionalnim ili mjestnim variantam, da bi one imjeli veće văzhodnih, sjevernih, zapadnih ili južnih črt."
        })]
      })]
    }), "\n", _jsx(CustomAfterSection, {})]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}

